import { getObject, setObject } from 'larasnap/support';

export default class {
    _props = {};
    _config = {};
    _handlers = [];

    setProps(key, value) {
        this._props = setObject(this._props, key, value);
        return this;
    }

    getProps(key) {
        return getObject(this._props, key);
    }

    setConfig(key, value) {
        this._config = setObject(this._config, key, value);
        return this;
    }

    getConfig(key) {
        return getObject(this._config, key);
    }

    getName() {
        return this._props.name;
    }

    setName(val) {
        this._props.name = val;
        return this;
    }

    getId() {
        return this._props.id;
    }

    setId(val) {
        this._props.id = val;
        return this;
    }

    setWrapper(val) {
        this._wrapper = val;
        return this;
    }

    getWrapper() {
        return this._wrapper;
    }

    /**************************************************************/
    //                      Find Element
    /**************************************************************/

    find(selector) {
        return this._wrapper.find(selector);
    }

    closest(selector) {
        return this._wrapper.closest(selector);
    }

    /**************************************************************/
    //                        Handlers
    /**************************************************************/

    runHandler(event, ...args) {
        let returnVal;

        this.getHandlers(event).forEach(handler => {
            returnVal = handler.func(...args);
        });

        return returnVal;
    }

    getHandlers(event) {
        return this._handlers.filter(x => x.event === event);
    }

    addHandler(event, func) {
        this._handlers.push({
            event,
            func,
        });
        return this;
    }
}
